import { FC } from 'react';

import { getHHLoginLinkWithBackUrl } from 'utils/clickme';

import { Link } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

export const Login: FC = () => {
    const trl = useTrls();

    const href = getHHLoginLinkWithBackUrl().href;

    if (!href) {
        return null;
    }

    return (
        <Link href={href} data-qa="login-link">
            {trl('header.login')}
        </Link>
    );
};
